import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Steps } from "antd";

const ProgressBarTransactionMode10 = (props) => {
  const { t } = useTranslation();
  const [currentStage, setCurrentStage] = useState(0);

  useEffect(() => {
    if (props.transaction) {
      if (
        props.transaction.agreement_accepted_by_counterparty === true &&
        props.transaction.agreement_accepted_by_initiator === true
      ) {
        setCurrentStage(1);

        if (props.transaction.escrow_received) {
          setCurrentStage(2);

          if (props.transaction.items_sent) {
            setCurrentStage(3);

            if (props.transaction.items_received) {
              setCurrentStage(4);

              if (
                props.transaction.inspection_completed_successfully === false
              ) {
                setCurrentStage(5);

                if (props.transaction.inspection_items_refused_sent) {
                  setCurrentStage(6);

                  if (props.transaction.inspection_items_refused_received) {
                    setCurrentStage(7);

                    if (
                      props.transaction
                        .inspection_items_refused_received_inspection_completed_success
                    ) {
                      setCurrentStage(8);

                      if (props.transaction.finished) {
                        setCurrentStage(9);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }, [props.transaction]);

  const steps = [
    {
      title: t('transaction.agreement.title'),
      description: t('transaction.progress.agreementNegotiationDesc'),
    },
    {
      title: t('transaction.progress.deposit'),
      description: t('transaction.progress.depositDesc'),
    },
    {
      title: t('transaction.progress.delivery'),
      description: t('transaction.progress.deliveryDesc'),
    },
    {
      title: t('transaction.progress.receipt'),
      description: t('transaction.progress.receiptDesc'),
    },
    {
      title: t('transaction.progress.inspection'),
      description: t('transaction.progress.inspectionFailure'),
      status: "error",
    },
    {
      title: t('transaction.progress.return'),
      description: t('transaction.progress.returnDesc'),
    },
    {
      title: t('transaction.progress.receipt'),
      description: t('transaction.progress.receiptDesc'),
    },    
    {
      title: t('transaction.progress.inspection'),
      description: t('transaction.progress.returnInspection'),
    },
    {
      title: t('transaction.progress.transactionEnd'),
      description: t('transaction.progress.fundsReturn'),
    },
  ];

  if (
    props.transaction !== null &&
    props.transaction.transaction_mode_id !== 10
  ) {
    return <></>;
  }

  if (props.transaction !== null) {
    return <Steps size="small" current={currentStage} items={steps} />;
  }
};

export default ProgressBarTransactionMode10;